// import React from "react";
// import { Search, Bell, User } from "lucide-react";
// import { useSelector } from "react-redux";

// const AdminHeader = () => {
//   const user = useSelector((state) => state?.user?.user);

//   return (
//     <div className="bg-white shadow-sm px-12 py-3 flex items-center border-b">
//       {user && <h1 className="text-xl font-bold text-[#414944]">Admin Panel</h1>}
//       {/* CENTER SEARCH */}
//       <div className="hidden md:flex flex-1 justify-center">
//         <div className="relative w-full max-w-md">
//           <Search
//             size={18}
//             className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
//           />
//           <input
//             type="text"
//             placeholder="Search global..."
//             className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#6f8f2f]"
//           />
//         </div>
//       </div>

//       {/* RIGHT SIDE */}
//       <div className="flex items-center gap-4 ml-auto flex-shrink-0">
//         <div className="relative cursor-pointer">
//           <Bell size={20} className="text-gray-600" />
//           <span ></span>
//         </div>

//         <div className="w-9 h-9 rounded-full bg-[#eef2e6] flex items-center justify-center cursor-pointer">
//           <User size={18} className="text-[#6f8f2f]" />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminHeader;


import React from "react";
import { Search, Bell, User, Menu, X } from "lucide-react"; // Menu மற்றும் X ஐகான்களைச் சேர்த்துள்ளேன்
import { useSelector } from "react-redux";

const AdminHeader = ({ mobileOpen, setMobileOpen }) => {
  const user = useSelector((state) => state?.user?.user);

  return (
    <div className="bg-white shadow-sm px-6 md:px-12 py-3 flex items-center border-b sticky top-0 z-[60]">
      {user && <h1 className="text-xl font-bold text-[#414944] flex-shrink-0 mr-2">Admin Panel</h1>}
      
      {/* CENTER SEARCH */}
      <div className="hidden md:flex flex-1 justify-center">
        <div className="relative w-full max-w-md">
          <Search
            size={18}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
          />
          <input
            type="text"
            placeholder="Search global..."
            className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#6f8f2f]"
          />
        </div>
      </div>

      {/* RIGHT SIDE */}
      <div className="flex items-center gap-2 md:gap-4 ml-auto flex-shrink-0">
        <div className="relative cursor-pointer p-2 hover:bg-gray-50 rounded-full transition">
          <Bell size={20} className="text-gray-600" />
        </div>

        <div className="w-9 h-9 rounded-full bg-[#eef2e6] flex items-center justify-center cursor-pointer border border-[#6f8f2f]/20">
          <User size={18} className="text-[#6f8f2f]" />
        </div>

        {/* MOBILE HAMBURGER MENU (Visible only on screens smaller than LG) */}
        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="lg:hidden p-2 ml-1 text-gray-600 hover:bg-gray-100 rounded-md transition-colors"
        >
          {mobileOpen ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>
    </div>
  );
};

export default AdminHeader;